import type { ResponseWithType, EventResponseRest } from './types';
import type { ResultEvent } from '../../types/events';

const eventResponse = ({ data }: ResponseWithType<EventResponseRest>): ResultEvent => {
  return {
    __typename: 'ResultEvent',
    id: data.id,
    ...data.event,
  };
};

export default eventResponse;
